import { importProvidersFrom, inject, provideAppInitializer } from '@angular/core';

import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { HttpErrorInterceptor } from './app/shared/HttpIntercepter/httpErrorInterceptor';
import { AppConfig } from './assets/config/appconfig';
import { AppRoutingModule } from './app/app-routing.module';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { CustomerModule } from './app/customer/customer.module';
import { AppComponent } from './app/app.component';

bootstrapApplication(AppComponent, {
    providers: [
        importProvidersFrom(AppRoutingModule, CustomerModule),
        { provide: HTTP_INTERCEPTORS, useClass: HttpErrorInterceptor, multi: true },
        provideHttpClient(withInterceptorsFromDi()),
        AppConfig,
        provideAppInitializer(() => {
            const appConfig = inject(AppConfig);
            return appConfig.load();
        }),
        provideAnimations()
    ]
})
  .catch(err => console.log(err));
